import { useCallback, useRef, useState } from 'react';

/** 管理可中止请求的生命周期，避免组件内分散管理 AbortController。 */
export function useAbortableRequest() {
  const controllerRef = useRef<AbortController | null>(null);
  const [isActive, setIsActive] = useState(false);

  const begin = useCallback(() => {
    controllerRef.current?.abort();
    const controller = new AbortController();
    controllerRef.current = controller;
    setIsActive(true);
    return controller;
  }, []);

  const abort = useCallback(() => {
    controllerRef.current?.abort();
    controllerRef.current = null;
    setIsActive(false);
  }, []);

  const clear = useCallback((controller: AbortController) => {
    if (controllerRef.current === controller) {
      controllerRef.current = null;
      setIsActive(false);
    }
  }, []);

  const getSignal = useCallback(() => controllerRef.current?.signal, []);

  return {
    isActive,
    begin,
    abort,
    clear,
    getSignal,
  };
}
